import { registerSW } from 'virtual:pwa-register';

export function setupPwa(): void {
  if (import.meta.env.DEV) return;
  registerSW({
    immediate: true,
    onOfflineReady() {
      console.log('[pwa] Gotowe do gry offline (shell)');
    },
    onNeedRefresh() {
      console.log('[pwa] Nowa wersja dostępna — autoUpdate');
    },
  });
}
